import React from 'react';

// styles
import styles from "../AddMeeting/AddMeeting.module.css"

const AddMeetingInput = (props) => {
    return (
        <>
            <div className={`position-relative d-flex align-items-start justify-content-center flex-column my-1 ${props.fullWidth && "w-100"}`}>
                <div className={`mb-3 ${styles.input_top_title}`}>
                    {props.title}
                </div>
                <input
                    className={`${props.fullWidth && "w-100"} ${styles.input}`}
                    type="text"
                    name={props.inputName}
                    value={props.inputValue}
                    onChange={props.onChange}
                />
                {props.meetingResponsible &&
                    <div className={styles.text_danger}>
                        مسئول نوشتن نتیجه جلسه
                    </div>
                }
            </div>
        </>
    );
};

export default AddMeetingInput;